import { useEffect } from 'react';
import { css } from 'styled-system/css';
import { CtaSection } from '../components/landing/CtaSection';
import { FaqSection } from '../components/landing/faq/FaqSection';
import { FeaturesSection } from '../components/landing/features/FeaturesSection';
import { FooterSection } from '../components/landing/FooterSection';
import { GoogleSheetsSection } from '../components/landing/googleSheets/GoogleSheetsSection';
import { HeroSection } from '../components/landing/hero/HeroSection';
import { Navigation } from '../components/landing/Navigation';
import { SubstrateSection } from '../components/landing/SubstrateSection';

const NOISE_SVG =
  "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E\")";

export function Home() {
  useEffect(() => {
    if (window.location.hash) {
      document.getElementById(window.location.hash.slice(1))?.scrollIntoView();
    }
  }, []);

  return (
    <div
      className={css({
        position: 'relative',
        minHeight: '100vh',
        background: 'bg.page',
        overflowX: 'clip',
      })}
    >
      <div
        aria-hidden="true"
        className={css({
          position: 'fixed',
          inset: 0,
          backgroundImage: NOISE_SVG,
          opacity: 0.03,
          pointerEvents: 'none',
          zIndex: 1,
        })}
      />
      <Navigation />
      <main>
        <HeroSection />
        <GoogleSheetsSection />
        <FeaturesSection />
        <SubstrateSection />
        <CtaSection />
        <FaqSection />
      </main>
      <FooterSection />
    </div>
  );
}
